import template from './check-publish.jade';

import { trackChangeVASPopupClick, trackChangeVASPopupShow } from './tracking';

export default [function() {
  return {
    template,
    restrict: 'AE',
    scope: {},
    bindToController: {
      data: '=',
      onConfirm: '&',
      onCancel: '&'
    },
    controllerAs: 'c',
    controller: ['$scope', function($scope) {
      if (this.data.servicesToDeactivate) {
        this.data.servicesToDeactivate.forEach(s => {
          if (s.serviceTypes.length == 1) {
            s.icon = s.serviceTypes[0];
          }
          else if (s.serviceTypes.length > 1 && s.serviceTypes.includes('premium')) {
            s.icon = 'premium';
          }
        });
      }

      $scope.onCancel = () => {
        trackChangeVASPopupClick('cancel');

        if (this.onCancel) {
          this.onCancel();
        }
      };

      $scope.onConfirm = () => {
        trackChangeVASPopupClick('continue');

        if (this.onConfirm) {
          this.onConfirm();
        }
      };

      trackChangeVASPopupShow();
    }]
  }
}];
